/* Outdoor Rabbit Hutch — locked-step slide navigation, same pattern as the
   walk-in coop showcase. Multiple real photos crossfade per chapter instead
   of a single Ken-Burns-panned image. */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var TRANSITION_MS = reduceMotion ? 60 : 1150;

  var slides = Array.prototype.slice.call(document.querySelectorAll(".slide"));
  var photos = Array.prototype.slice.call(document.querySelectorAll(".photo-slide"));
  var chips = Array.prototype.slice.call(document.querySelectorAll(".chips button"));
  var prevBtn = document.getElementById("prevBtn");
  var nextBtn = document.getElementById("nextBtn");
  var stepNow = document.getElementById("stepNow");

  var idx = 0;
  var locked = false;
  var total = slides.length;

  function render() {
    slides.forEach(function (s, i) { s.classList.toggle("active", i === idx); });
    photos.forEach(function (p) { p.classList.toggle("active", parseInt(p.getAttribute("data-p"), 10) === idx); });
    chips.forEach(function (c, i) { c.classList.toggle("active", i === idx); });
    stepNow.textContent = idx + 1;
    prevBtn.disabled = idx === 0;
    nextBtn.disabled = idx === total - 1;
  }

  function goTo(i) {
    i = Math.max(0, Math.min(total - 1, i));
    if (i === idx || locked) return;
    idx = i;
    render();
    locked = true;
    setTimeout(function () { locked = false; }, TRANSITION_MS);
  }

  prevBtn.addEventListener("click", function () { goTo(idx - 1); });
  nextBtn.addEventListener("click", function () { goTo(idx + 1); });
  chips.forEach(function (c) {
    c.addEventListener("click", function () { goTo(parseInt(c.getAttribute("data-i"), 10)); });
  });

  var wheelAccum = 0;
  window.addEventListener("wheel", function (e) {
    e.preventDefault();
    if (locked) return;
    wheelAccum += e.deltaY;
    if (Math.abs(wheelAccum) > 24) {
      goTo(idx + (wheelAccum > 0 ? 1 : -1));
      wheelAccum = 0;
    }
  }, { passive: false });

  window.addEventListener("keydown", function (e) {
    if (["ArrowDown", "PageDown", " "].indexOf(e.key) !== -1) { e.preventDefault(); goTo(idx + 1); }
    else if (["ArrowUp", "PageUp"].indexOf(e.key) !== -1) { e.preventDefault(); goTo(idx - 1); }
    else if (e.key === "Home") { goTo(0); }
    else if (e.key === "End") { goTo(total - 1); }
  });

  var touchStartY = null;
  window.addEventListener("touchstart", function (e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  window.addEventListener("touchmove", function (e) {
    e.preventDefault();
  }, { passive: false });
  window.addEventListener("touchend", function (e) {
    if (touchStartY === null) return;
    var dy = touchStartY - e.changedTouches[0].clientY;
    touchStartY = null;
    if (Math.abs(dy) > 40) goTo(idx + (dy > 0 ? 1 : -1));
  }, { passive: true });

  render();

  // Preloader — wait on the hero photo (the only chapter-0 asset), with a
  // hard display:none once faded (transitioned visibility is unreliable for
  // hit-testing across browsers — learned from the coop showcase build).
  var pre = document.getElementById("pre");
  var heroPhoto = document.querySelector('.photo-slide[data-p="0"]');
  var preFinished = false;
  function finishLoad() {
    if (preFinished) return;
    preFinished = true;
    pre.style.opacity = "0";
    setTimeout(function () { pre.style.display = "none"; }, 550);
  }
  if (heroPhoto.complete) { finishLoad(); }
  else {
    heroPhoto.addEventListener("load", finishLoad);
    heroPhoto.addEventListener("error", finishLoad);
  }
  setTimeout(finishLoad, 2500);
})();
